module.exports = __webpack_public_path__ + "img/num1.2dc355e1.jpg";